'use client'

import React from 'react'
import { GlowButton } from '@/components/ui/GlowButton'
import classes from './SectionHeader.module.css'

interface SectionHeaderProps {
  title: string
  href: string
  buttonLabel: string
  testId?: string
}

export const SectionHeader = ({
  title,
  href,
  buttonLabel,
  testId,
}: SectionHeaderProps) => {
  return (
    <div className={classes.sectionHeader}>
      <h2 data-testid={testId} className={classes.title}>
        {title}
      </h2>
      <GlowButton href={href} className="w-full sm:w-auto mt-2 sm:mt-0">
        {buttonLabel}
      </GlowButton>
    </div>
  )
}
